import React from 'react';
import { Link } from 'react-router-dom';
import { LANDING } from '@/constants/testIds';

export const Footer = () => {
    return (
        <footer
            data-testid={LANDING.footer}
            className="border-t border-white/5 bg-black py-12"
        >
            <div className="max-w-7xl mx-auto px-5 sm:px-8 flex flex-col sm:flex-row items-center justify-between gap-5">
                <div className="flex items-center gap-2">
                    <div className="w-6 h-6 rounded-md bg-[#b8ff00] flex items-center justify-center">
                        <svg
                            viewBox="0 0 24 24"
                            className="w-3.5 h-3.5 text-black"
                            fill="currentColor"
                        >
                            <path d="M13 2 3 14h7l-1 8 10-12h-7l1-8z" />
                        </svg>
                    </div>
                    <span className="text-white text-sm font-semibold tracking-tight">
                        HyperTroop<span className="text-[#b8ff00]">.Fit</span>
                    </span>
                </div>

                <div className="flex items-center gap-7 text-xs text-[#8e8e93]">
                    <Link
                        to="/privacy-policy"
                        data-testid={LANDING.footerLinkPrivacy}
                        className="hover:text-[#b8ff00] transition-colors"
                    >
                        Privacy Policy
                    </Link>
                    <Link
                        to="/terms-of-use"
                        data-testid={LANDING.footerLinkTerms}
                        className="hover:text-[#b8ff00] transition-colors"
                    >
                        Terms of Use
                    </Link>
                    <a
                        href="mailto:support@hypertroop.fit"
                        data-testid={LANDING.footerLinkContact}
                        className="hover:text-[#b8ff00] transition-colors"
                    >
                        Contact
                    </a>
                </div>

                <div className="text-xs text-[#8e8e93]">
                    © 2026 HyperTroop.Fit. All rights reserved.
                </div>
            </div>
        </footer>
    );
};

export default Footer;
